// ES classes have titles like "1. PRIM", "2. ESO", grouped into ranges per suffix
export const NUMBERED_GRADE_RE = /^(\d+)\. (PRIM|ESO|BACH|CFGM|CFGS|FPB)$/;

export type GroupedSuffix = 'PRIM' | 'ESO' | 'BACH' | 'CFGM' | 'CFGS' | 'FPB';

const isESClass = ({ title }: MaterialClassGrade): boolean => NUMBERED_GRADE_RE.test(title);

export default isESClass;
